<div class="h-100 overflow-auto crm-scroll">
  <div class="d-flex flex-row align-items-center justify-content-between px-4 py-3">
    <h4 class="m-0 text-crm">{{ 'updating' | translate }} {{ manager?.first_name | fullName: manager?.last_name }}</h4>
    @if (baseService.isMobile) {
      <app-button (onChangeClick)="onCloseSidebar()" [btnType]="'icon'" matTooltip="{{ 'close' | translate }}">
        <app-icon>close</app-icon>
      </app-button>
    }
  </div>

  <mat-divider class="my-2"></mat-divider>

  @if (updateManagerForm) {
    <div>
      <div class="d-flex flex-column gap-3 px-4 py-2" [formGroup]="updateManagerForm">
        <app-select
          [options]="groups"
          (valueChange)="this.updateManagerForm.markAllAsTouched()"
          [formControl]="updateManagerForm.controls.group_id"
          label="{{ 'role' | translate }}"
          optionLabel="name"
          optionValue="id"
          placeholder="{{ 'choose_role' | translate }}"
          [error]="updateManagerForm.controls.group_id.touched && updateManagerForm.controls.group_id.invalid"
        />
      </div>
      <div class="d-flex gap-2 p-4">
        <app-button class="mt-2" (onChangeClick)="onCloseSidebar()">{{ 'cancel' | translate }}</app-button>
        <app-button
          [customClass]="isHasChange && updateManagerForm.valid ? 'bg-success' : ''"
          class="mt-2"
          (onChangeClick)="onUpdateManager()"
          [disabled]="!isHasChange && !(managers && managers.length)"
          >{{ 'save' | translate }}
        </app-button>
        <div class="flex-fill"></div>
        @if (canManageTeam && manager) {
          <app-button
            class="mt-2"
            customClass="bg-danger"
            [btnType]="'default'"
            [disabled]="manager?.role === 'OWNER'"
            matTooltip="{{ 'notifications_texts.error.cannot_remove_owner' | translate }}"
            [matTooltipDisabled]="manager?.role !== 'OWNER'"
            (onChangeClick)="onDeleteManager()"
          >
            <app-icon class="text-white">delete</app-icon>
          </app-button>
        }
      </div>
    </div>
  }
</div>
